import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Description } from '@material-ui/icons';
import { colors } from '@skyslope/mache';
import { twMerge } from 'tailwind-merge';
import { useShallowSelector, useDispatch } from '../../lib/reduxHooks';
import * as actions from './../../store/senderBuild/actions';

const useStyles = makeStyles(() => ({
  selected: {
    '&.Mui-selected': {
      backgroundColor: colors.blue[50],
      '&::after': {
        content: "''",
        position: 'absolute',
        height: '40px',
        width: '4px',
        background: colors.blue[800],
        left: '0px',
        top: '0px',
      },
    },
  },
}));

export function DocumentList() {
  const {
    documents,
    currentDocument = '',
    applyTemplateToDocumentId,
  } = useShallowSelector((state) => ({
    documents: state.senderBuild.documents,
    currentDocument: state.senderBuild.currentDocument,
    applyTemplateToDocumentId: state.senderBuild.applyTemplateToDocumentId,
  }));

  const classes = useStyles();
  const dispatch = useDispatch();

  function handleDocumentClick(documentId: string) {
    dispatch(actions.setCurrentDocument(documentId));
    const doc = document.getElementById(`doc-${documentId}-page-0`);
    if (doc) {
      doc!.scrollIntoView();
      const pdfViewer = document.querySelector('.PdfViewer');
      pdfViewer!.scrollTop -= 90;
    }
  }

  return (
    <List className="-mr-6">
      {documents.map((document, _i) => {
        let isLockedInForApplyTemplate = document.documentId === applyTemplateToDocumentId;
        let isSelectedDocument = document.documentId === currentDocument;

        return (
          <ListItem
            id={`Document_${document.fileName}`}
            key={document.documentId}
            selected={isSelectedDocument}
            classes={{
              selected: classes.selected,
              root: twMerge('p-0 border border-transparent', isSelectedDocument && 'bg-blue-50'),
            }}
            data-spec={`doc-${document.documentId}`}
            tabIndex={0}
          >
            <button
              className={twMerge(
                'h-10 w-full flex items-center',
                'py-3 px-4 cursor-pointer hover:bg-grey-200',
                'overflow-hidden break-all whitespace-pre bg-transparent'
              )}
              onClick={() => handleDocumentClick(document.documentId)}
            >
              <Description
                className={twMerge('mr-4 text-grey-500 w-7 h-7', isLockedInForApplyTemplate && 'text-blue-800')}
              />
              <div title={document.fileName} className="overflow-hidden">
                <Typography
                  variant="body1"
                  className={twMerge('overflow-hidden text-ellipsis', isLockedInForApplyTemplate && 'text-blue-800')}
                >
                  {document.fileName}
                </Typography>
              </div>
            </button>
          </ListItem>
        );
      })}
    </List>
  );
}
